import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Mounts inside the router. Whenever the user navigates to a new pathname
 * (e.g. clicking a navbar link, a collection tile, a product card), we
 * scroll the window back to the top. Hash-based jumps within the same
 * page are left alone so #collections / #shop anchors still work.
 */
export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) return; // let the destination page handle hash scrolling
    // Instant for cross-page transitions so the new hero is what you see first.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, key, hash]);

  return null;
}